import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-logo-design',
  templateUrl: './logo-design.component.html',
  styleUrls: ['./logo-design.component.scss']
})
export class LogoDesignComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Logo Design - Xipe Tech';
  contentDescription = 'XipeTech offers professional logo design services that bring your brand vision to life. We create unique, memorable, and high-quality logos to help businesses stand out in today’s competitive market.';
  contentKeywords = 'logo design, custom logo, professional logo design, brand identity, creative logo, business logo, graphic design, custom branding, unique logo, logo creation services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
